import React from 'react';
import { ThumbsDown, ThumbsUp } from 'lucide-react';
import { classifierLabel } from '../../../services/classifiersApi';
import { formatCount, formatRelativeTime } from '../../../utils/formatters';
import { components, palette } from '../../../utils/designTokens';
import { statusStyle } from './rcaHelpers';

export default function RcaCard({ rca, selected, onSelect }) {
  const feedback = rca.feedback || {};
  return (
    <button
      type="button"
      className={`w-full rounded-lg border p-4 text-left transition-colors ${
        selected
          ? 'border-accent-primary-base bg-accent-primary-base/10'
          : 'border-border-subtle bg-background-secondary hover:bg-background-tertiary'
      }`}
      onClick={() => onSelect(rca.rca_id)}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="truncate text-sm font-semibold text-text-primary">
            {rca.title || classifierLabel(rca.classifier_key)}
          </div>
          <div className="mt-1 text-[11px] text-text-muted">
            {classifierLabel(rca.classifier_key)} · v{rca.classifier_version}
          </div>
        </div>
        <span
          className={`shrink-0 border uppercase ${components.badge.padding} ${components.badge.rounded} ${components.badge.size} ${components.badge.weight}`}
          style={statusStyle(rca.status)}
        >
          {rca.status || 'open'}
        </span>
      </div>

      <p className="mt-3 line-clamp-2 text-xs leading-relaxed text-text-muted">
        {rca.summary || rca.root_cause || 'No summary available.'}
      </p>

      <div className="mt-3 flex flex-wrap gap-2 text-[11px] text-text-muted">
        <span>{formatCount(rca.trace_count)} traces</span>
        <span>{formatCount(rca.service_count)} services</span>
        {rca.new_occurrences_since_resolved > 0 && (
          <span style={{ color: palette.status.warning }}>{rca.new_occurrences_since_resolved} new since resolve</span>
        )}
      </div>
      <div className="mt-2 flex flex-wrap gap-2 text-[11px] text-text-muted">
        <span className="inline-flex items-center gap-1">
          <ThumbsUp size={11} />
          {feedback.thumbs_up || 0}
        </span>
        <span className="inline-flex items-center gap-1">
          <ThumbsDown size={11} />
          {feedback.thumbs_down || 0}
        </span>
        {rca.last_seen && <span>{formatRelativeTime(rca.last_seen)}</span>}
      </div>
    </button>
  );
}
